import { useEffect, useState } from 'react';
import axios from 'axios';
import { btnOneLight, containerOne, subTitle, title } from '../utils/style';
import { url } from '../utils/config';
import { toast } from 'react-toastify';
import loaderStateAtom from '../atoms/loaderStateAtom';
import { useRecoilState } from 'recoil';
import uiConfigAtom from '../atoms/uiConfigAtom';
import { useNavigate } from 'react-router-dom';
import addIcon from '../assets/icons/add_icon.png'
import LeaveRequestForm from './LeaveRequestForm';
import HolidayCalendar from './HolidayCalendar';
import LeaveCard from './LeaveCard';
import SliderCalendar from './SliderCalendar';
import navHeaderAtom from '../atoms/navHeaderAtom';
import compareDate from '../helper_functions/compareDate';
import textValidator from '../helper_functions/textValidator';

function Leave() {
    const [ leaveList, setLeaveList ] = useState([]);
    const [ holidays, setHolidays ] = useState([]);
    const [ leaveBalance, setLeaveBalance ] = useState('');
    const [ status, setStatus ] = useState('Past')
    const [ showForm, setShowForm ] = useState(false)
    const [ showLoader, setShowLoader ] = useRecoilState(loaderStateAtom);
    const [ uiConfig ] = useRecoilState(uiConfigAtom);
    const [ header, setHeader ] = useRecoilState(navHeaderAtom)
    const navigate = useNavigate();

    const style = {
        backgroundColor: uiConfig?.table?.headerColor?.hex,
        color: uiConfig?.table?.fontColor?.hex
    }

    useEffect(() => {
        setHeader('Leaves')
        getLeavesData()
    }, [])

    async function getLeavesData() {
        try {
            setShowLoader(true)
            const reqUrl = url + '/leaves_info';
            const token = window.localStorage.getItem('token');
            const headers = { authorization: `bearer ${token}` };
            const { data } = await axios.get(reqUrl, { headers });
            setLeaveList(data.leaves)
            setLeaveBalance(data.leaveBalance.leaveBalance);
            setHolidays(data.holidays)
            setShowLoader(false)
        } catch (error) {
            setShowLoader(false)
            // toast.error(error?.response?.data?.message, { autoClose: 3000 })
        }
    }

    async function requestLeave(leaveData) {
        if (!leaveData.date || !leaveData.reason) {
            toast.error('Date & Reason cannot be empty!', { autoClose: 3000 })
            return;
        }
        if(!textValidator(leaveData.reason)) {
            toast.error('Reason can not contain numbers!', { autoClose: 3000 })
            return;
        }
        if(compareDate(leaveData.date) === 'future' || compareDate(leaveData.date) === 'present') {
            try {
                setShowLoader(true)
                const reqUrl = url + '/leave_request';
                const token = window.localStorage.getItem('token');
                const headers = { authorization: `bearer ${token}` };
                const data = await axios.post(reqUrl, leaveData, { headers });
                console.log(data.data);
                toast.success(data?.data?.message, { autoClose: 3000 })
                getLeavesData();
                setShowLoader(false)
                setShowForm(false)
            } catch (error) {
                setShowLoader(false)
                setShowForm(false)
                toast.error(error?.response?.data?.message, { autoClose: 3000 })
            }
        } else {
            toast.error('Past Date Cannot be selected!', { autoClose: 3000 })
        }
    }


    

    return(
        !showForm ? 
        <div className={containerOne}>
            <div>
                <SliderCalendar />
            </div>
            <div className='flex justify-between'>
                <div className={title}>All Leaves</div>
                <div className='cursor-pointer'><img src={addIcon} onClick={() => setShowForm(true)}/></div>
            </div>
            <div className='flex justify-between gap-4 w-full mt-4'>
                <div className='bg-[#F0F4F8] w-full p-4 rounded-xl border border-[#0664B8]'>
                    <div className={subTitle}>Leave Balance</div>
                    <div className={'text-right' + ' ' + subTitle}>{leaveBalance}</div>
                </div>
                <div className='bg-[#EDF4E4] w-full p-4 rounded-xl border border-[#4F6F25]'>
                    <div className={subTitle}>Leaves Approved</div>
                    <div className={'text-right' + ' ' + subTitle}>{leaveList.filter(lv => lv.status === 'Approved').length}</div>
                </div>
            </div>
            <div className='flex justify-between gap-4 w-full mt-4 mb-8'>
                <div className='bg-[#D8E4E3] w-full p-4 rounded-xl border border-[#2D928B]'>
                    <div className={subTitle}>Leaves Pending</div>
                    <div className={'text-right' + ' ' + subTitle}>{leaveList.filter(lv => lv.status === 'Pending').length}</div>
                </div>
                <div className='bg-[#F7EBEB] w-full p-4 rounded-xl border border-[#A45D5D]'>
                    <div className={subTitle}>Leaves Rejected</div>
                    <div className={'text-right' + ' ' + subTitle}>{leaveList.filter(lv => lv.status === 'Rejected').length}</div>
                </div>
            </div>
            <div className="flex text-sm text-customOne font-semibold border-2 border-customOne rounded-full p-1 mb-4">
                <div className={`flex-1 px-4 py-2 text-center cursor-pointer ${status === 'Upcoming' && 'text-white bg-customOne rounded-full'}`} onClick={() => setStatus('Upcoming')}>Upcoming</div>
                <div className={`flex-1 px-4 py-2 text-center cursor-pointer ${status === 'Past' && 'text-white bg-customOne rounded-full'}`} onClick={() => setStatus('Past')}>Past</div>
                <div className={`flex-1 px-4 py-2 text-center cursor-pointer ${status === 'Holiday' && 'text-white bg-customOne rounded-full'}`} onClick={() => setStatus('Holiday')}>Holiday</div>
            </div>
            <div>
                {
                    status === 'Upcoming' &&
                    leaveList.filter(leave => compareDate(leave.date) === 'future')
                    .sort((a, b) => b.date > a.date).reverse()
                    .map((leave, ind) => <LeaveCard key={ind} leave={leave}/>)
                }
            </div>
            <div>
                {
                    status === 'Past' &&
                    leaveList.filter(leave => compareDate(leave.date) !== 'future')
                    .sort((a, b) => b.date > a.date).reverse()
                    .map((leave, ind) => <LeaveCard key={ind} leave={leave} />)
                }
            </div>
            {
                status ===  'Holiday' &&
                <div  className='flex justify-center w-full'>
                    <HolidayCalendar holidays={holidays} />
                </div>
            }
        </div>
        :
        <LeaveRequestForm setShowForm={setShowForm} submitHandler={requestLeave} />
    )
}

export default Leave;
